<template>
<div id="prepare-login">
  <img
    src="@/assets/loading.gif"
    alt="loading">
</div>
</template>

<script>
export default {
  mounted () {
    this.$auth.handleAuthentication().then(() => {
      this.$router.push({ name: 'selectStore'})
    })
  }
}
</script>
<style lang="css" scoped>
  #prepare-login {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
  }
</style>
